import React, { useEffect, useState } from 'react';
import { useLocation, Link, useParams } from 'react-router-dom';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import { useNavigate } from 'react-router-dom';
import CreateBrandForm from './CreateBrandForm';
import PermissionManagement from '../Permission';
import RoleManagement from '../Role';
import UserManagement from '../User';
import { useSelector } from 'react-redux';
import StoreManagement from '../stores'; // Import the existing StoreManagement component
import AvailableStores from '../AvailableStores';

const BrandManagement = () => {
  const { pathname } = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const { userPermissions } = useSelector((state) => state?.user || {});

  const brandId = params?.brandId?.toUpperCase()?.replaceAll('-', '_');

  const [activeTab, setActiveTab] = useState('0');

  const permissionCheck = (permissions) =>
    permissions.some((permission) => userPermissions?.includes(permission));

  const canManageRole = permissionCheck(['manage_all', 'manage_role']);
  const canViewRoleList = permissionCheck([
    'manage_all',
    'manage_role',
    'list_role',
  ]);

  const canManagePermission = permissionCheck([
    'manage_all',
    'manage_permission',
  ]);

  const canViewPermissionList = permissionCheck([
    'manage_all',
    'manage_permission',
    'list_permission',
  ]);

  const canManageUser = permissionCheck(['manage_all', 'manage_user']);
  const canViewUserList = permissionCheck([
    'manage_all',
    'manage_user',
    'list_user',
  ]);

  const canManageBrand = permissionCheck(['manage_all', 'manage_brand']);
  const canViewBrand = permissionCheck([
    'manage_all',
    'manage_brand',
    'view_brand',
  ]);

  const canManageStores = permissionCheck(['manage_all', 'manage_store']);
  const canViewStoreList = permissionCheck([
    'manage_all',
    'manage_store',
    'list_store',
  ]);

  useEffect(() => {
    let selectedTab = '0';
    switch (pathname) {
      case `/brand/${params?.brandId}/basic`:
        selectedTab = '0';
        break;
      case `/brand/${params?.brandId}/users`:
        selectedTab = '1';
        break;
      case `/brand/${params?.brandId}/roles`:
        selectedTab = '2';
        break;
      case `/brand/${params?.brandId}/permissions`:
        selectedTab = '3';
        break;
      case `/brand/${params?.brandId}/stores`:
        selectedTab = '4';
        break;

      default:
        selectedTab = '0';
    }
    setActiveTab(selectedTab);
  }, [pathname]);

  useEffect(() => {
    if (params?.id !== 'new') {
    }
  }, [params?.id]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="page-content p-4">
      <Nav
        tabs
        className="nav nav-tabs-custom bg-light-subtle rounded-top-3 border"
      >
        {canManageBrand || canViewBrand ? (
          <NavItem>
            <NavLink
              className={`${
                activeTab === '0' ? 'active' : ''
              } d-flex align-items-center justify-content-center gap-2 py-3 px-4`}
              onClick={() => toggle('0')}
              tag={Link}
              to={`/brand/${params?.brandId}/basic`}
            >
              <i className="bx bx-cog fs-18"></i>
              Basic Details
            </NavLink>
          </NavItem>
        ) : null}
        {canManageUser || canViewUserList ? (
          <NavItem>
            <NavLink
              className={`${
                activeTab === '1' ? 'active' : ''
              } d-flex align-items-center justify-content-center gap-2 py-3 px-4`}
              onClick={() => toggle('1')}
              tag={Link}
              to={`/brand/${params?.brandId}/users`}
            >
              <i className="bx bx-user fs-18 "></i>
              Users
            </NavLink>
          </NavItem>
        ) : null}
        {canManageRole || canViewRoleList ? (
          <NavItem>
            <NavLink
              className={`${
                activeTab === '2' ? 'active' : ''
              } d-flex align-items-center justify-content-center gap-2 py-3 px-4`}
              onClick={() => toggle('2')}
              tag={Link}
              to={`/brand/${params?.brandId}/roles`}
            >
              <i className="bx bx-user-check fs-18"></i>
              Roles
            </NavLink>
          </NavItem>
        ) : null}
        {canManagePermission || canViewPermissionList ? (
          <NavItem>
            <NavLink
              className={`${
                activeTab === '3' ? 'active' : ''
              } d-flex align-items-center justify-content-center gap-2 py-3 px-4`}
              onClick={() => toggle('3')}
              tag={Link}
              to={`/brand/${params?.brandId}/permissions`}
            >
              <i className="bx bx-shield fs-18"></i>
              Permissions
            </NavLink>
          </NavItem>
        ) : null}
        {canManageStores || canViewStoreList ? (
          <NavItem>
            <NavLink
              className={`${
                activeTab === '4' ? 'active' : ''
              } d-flex align-items-center justify-content-center gap-2 py-3 px-4`}
              onClick={() => toggle('4')}
              tag={Link}
              to={`/brand/${params?.brandId}/stores`}
            >
              <i className="bx bx-store fs-18"></i>
              Manage Stores
            </NavLink>
          </NavItem>
        ) : null}
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={activeTab}>
          <div className="p-4 border border-top-0 rounded-3 rounded-top-0">
            {activeTab === '0' && (canManageBrand || canViewBrand) ? (
              <CreateBrandForm brandId={brandId} isFromPopup={false} />
            ) : null}
            {activeTab === '1' && (canManageUser || canViewUserList) ? (
              <UserManagement
                brandId={brandId}
                isFromPopup={false}
                subject="brand"
              />
            ) : null}
            {activeTab === '2' && (canManageRole || canViewRoleList) ? (
              <RoleManagement brandId={brandId} subject="brand" />
            ) : null}
            {activeTab === '3' &&
            (canManagePermission || canViewPermissionList) ? (
              <PermissionManagement brandId={brandId} subject="brand" />
            ) : null}
            {activeTab === '4' && (canManageStores || canViewStoreList) ? (
              <AvailableStores
                brandId={brandId}
                // selectedBrand={selectedBrand}
                // countryProp={selectedCountry}
              />
            ) : null}
          </div>
        </TabPane>
      </TabContent>
    </div>
  );
};

export default BrandManagement;
